<template>
  <div id="contact">
    <!-- 联系我们 -->
    <div class="contact">
      <div class="main">
        <div class="left">
          <div class="title">Contact</div>
          <p>
            If you have any questions do not hesitate to contact us. Our staff
            will be happy to assist with any inquiry you might have.
          </p>
          <div class="left-content1" data-wow-delay=".2s">
            <p class="des">
              <img src="../assets/img/about/page6-2.png" alt="" />
              <span>Email: ezzloc@daovay.com</span>
            </p>
            <p class="des">
              <img src="../assets/img/about/page6-1.png" alt="" />
              <span>Phone: 029-88228872</span>
            </p>
            <p class="des">
              <img src="../assets/img/about/page6-3.png" alt="" />
              <span>WhatsApp: +86 18966827856</span>
            </p>
            <p class="des">
              <img src="../assets/img/about/page6-4.png" alt="" />
              <span
                >Address: Room 518, Building C, Yijietong New Retail Digital
                Industrial Park, Baoan District, Shenzhen, 518100, China</span
              >
            </p>
          </div>
        </div>
        <div class="right">
          <div class="title">Leave A Message</div>
          <el-form
            :model="form"
            size="medium"
            ref="queryForm"
            :rules="rules"
            @submit.native.prevent
          >
            <el-form-item prop="contacts">
              <el-input v-model="form.contacts" placeholder="Name" />
            </el-form-item>

            <el-form-item prop="email">
              <el-input v-model="form.email" placeholder="Email" />
            </el-form-item>
            <!-- <el-form-item prop="tel">
                <el-input
                  v-model="form.tel"
                  size="medium"
                  placeholder="请输入您的联系电话"
                />
              </el-form-item> 
              <el-form-item prop="address">
                <el-input
                  v-model="form.address"
                  size="medium"
                  placeholder="请输入您的联系地址"
                />
              </el-form-item> -->
            <el-form-item prop="message">
              <el-input
                v-model="form.message"
                type="textarea"
                rows="6"
                placeholder="Message"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                :loading="loading"
                style="
                  padding: 10px 50px;
                  background-color: #00bebe;
                  border-color: #00bebe;
                  font-weight: bold;
                "
                @click="submit"
                >S U B M I T</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-footer class="footer" height="auto">
      <div class="index-container">
        <div class="footer-body">
          <div class="left">
            <router-link :to="{ name: 'home' }">
              <img :src="logoSrc1" alt="" style="width: 200px; height: auto" />
            </router-link>
            <div class="leftF">
              <div>
                <h3>Product</h3>
                <!-- <router-link :to="{ name: 'senthing' }">
                  <span></span>
                </router-link> -->
                <div class="router2">
                  <div v-for="(item, index) in tabList" :key="index">
                    <router-link :to="{ path: '/product/' + item.type }">
                      <span>{{ item.name }}</span>
                    </router-link>
                  </div>
                  <!-- <div>
                    <router-link :to="{ name: 'senthing' }">
                      <span>WJ1</span>
                    </router-link>
                  </div> -->
                </div>
              </div>
              <div>
                <h3>Sulutions</h3>
                <div class="router2">
                  <div v-for="(item, index) in solutions" :key="index">
                    <router-link :to="{ path: '/solutionsdetails/' + item.id }">
                      <span>{{ item.name }}</span>
                    </router-link>
                  </div>
                </div>
              </div>
              <div>
                <h3>Contact Us</h3>
                <div class="footerMenu">
                  <!-- <li>Tel:<a href="tel:"> </a></li> -->
                  <div class="li">
                    E-mail:<a href="mailto:Ezzloc@daovay.com">
                      Ezzloc@daovay.com
                    </a>
                  </div>
                  <div class="li">
                    <p>
                      Add: Room 518, Building C, Yijietong New Retail Digital
                      Industrial Park, Baoan District, Shenzhen, 518100, China
                    </p>
                  </div>
                </div>
                <div class="footerShare">
                  <a
                    href="https://www.instagram.com/"
                    class="icon"
                    target="_blank"
                  >
                    <svg-icon icon-class="ins" />
                  </a>
                  <a href="https://youtube.com/" class="icon" target="_blank">
                    <svg-icon icon-class="Youtube" />
                  </a>
                  <a href="https://facebook.com/" class="icon" target="_blank">
                    <svg-icon icon-class="facebook" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="right" data-wow-delay=".8s">
            <img src="../assets/img/wx.jpg" alt="微信服务号" class="img" />
            <p class="des">微信服务号</p>
          </div> -->
        </div>
        <div class="el-login-footer" style="text-align: center;color:#fff;position:absolute;bottom:5px;width:100%;">
          © 2016 - {{ nowYear }} - Shenzhen Daovay Technology Co.,Ltd
            <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备16092101号-1</a>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script>
var validator = (rule, value, callback) => {
  var reg = /^1[3456789]\d{9}$/;
  if (value == "" || reg.test(value) === false) {
    callback(new Error("请输入正确的联系电话"));
  } else {
    callback();
  }
};
var validatorEmail = (rule, value, callback) => {
  var reg = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
  if (value == "" || reg.test(value) === false) {
    callback(new Error("Email"));
  } else {
    callback();
  }
};
import JSON from "../utils/solutions.js";
export default {
  name: "v-footer",
  data() {
    return {
      nowYear: "",
      form: {
        contacts: "",
        // tel: "",
        email: "",
        // address: "",
        message: "",
      },
      rules: {
        contacts: [{ required: true, message: "Name", trigger: "blur" }],
        // tel: [{ validator: validator, required: true, trigger: "blur" }],
        email: [{ validator: validatorEmail, required: true, trigger: "blur" }],
      },
      logoSrc1: require("../assets/img/logo_Y.png"),
      tabList: [
        {
          name: "Hardwired Tracker",
          type: 1,
          img: require("../assets/img/product/navList/HardwiredTracker.png"),
        },
        {
          name: "OBD Tracker",
          type: 2,
          img: require("../assets/img/product/navList/OBDTracker.png"),
        },
        {
          name: "Video Terminal",
          type: 3,
          img: require("../assets/img/product/navList/VideoTerminal.png"),
        },
        {
          name: "Tire Pressure Monitoring",
          type: 4,
          img: require("../assets/img/product/navList/TirePressureMonitoring.png"),
        },
        {
          name: "Portable Tracker",
          type: 5,
          img: require("../assets/img/product/navList/PortableTracker.png"),
        },
        {
          name: "Sensor Accessories",
          type: 6,
          img: require("../assets/img/product/navList/SensorAccessories.png"),
        },
      ],
      solutions: JSON.list,
      loading: false,
    };
  },
  mounted() {
    var myDate = new Date();
    this.nowYear = myDate.getFullYear();
  },
  methods: {
    submit() {
      var data = this.form;
      console.log(data);
      this.$refs["queryForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .post(`reservationDemoSubmit`, data)
            .then((response) => {
              this.loading = false;
              if (response.data && response.data.code == 200) {
                this.$message({
                  showClose: true,
                  message:
                    "Thank you for contacting us. We have received your message and will get back to you shortly.",
                  type: "success",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: response.msg,
                  type: "error",
                });
              }
            })
            .catch(function (error) {
              this.loading = false;
              window.console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
#contact {
  position: relative;
  z-index: 10;
}
.contact {
  width: 100%;
  padding: 5vh 0;
  background-color: #fff;

  .main {
    width: 80%;
    margin: 0 auto;
    padding: 5vh;
    display: flex;
    justify-content: space-between;
    // background-color: #273043;
    .title {
      font-size: 6vh;
      line-height: 35px;
      font-weight: 800;
      // padding-top: 100px;
      color: #333;
      margin-bottom: 40px;
    }
    .left {
      width: 47%;
      p {
        font-size: 2vh;
        line-height: 3vh;
        margin-bottom: 3vh;
      }
      .des {
        font-size: 2vh;
        margin-bottom: 2vh;
        display: flex;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
          margin-right: 10px;
          vertical-align: middle;
        }
        span {
          width: calc(100% - 40px);
        }
      }
    }
    .right {
      width: 47%;
      form {
        width: 80%;
        background-color: #fff;
        border-radius: 10px;
      }
      .el-form-item {
        input,
        textarea {
          color: #333;
          font-size: 14px;
          font-family: "Helvetica Neue", Helvetica, Arial, "Microsoft YaHei",
            sans-serif;
          &::placeholder {
            font-size: 14px;
          }
        }
      }
      ::v-deep .el-form-item__label {
        font-size: 17px;
        font-weight: normal;
      }
    }
    .border {
      height: 2px;
      background-color: #eee;
      width: 50px;
      margin: 0 auto;
      margin-bottom: 5vh;
    }
  }
}
.footer {
  position: relative;
  overflow: hidden;
  z-index: 10;
  background-color: #06060b;
  background-size: 100% 100%;
  .index-container {
    display: block;
    width: 80%;
    margin: 0 auto;
    padding: 30px 0 100px;
    position:relative;
    .footer-head {
      padding: 30px 0;
      border-bottom: 1px solid #242424;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        height: 60px;
      }
    }
    .footer-body {
      margin-top: 35px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        width: 100%;
        display: flex;
        overflow: hidden;
        // margin: 0 -35px;
        .leftF {
          display: flex;
          justify-content: space-around;
          align-items: flex-start;
          width: 100%;
          margin-left: 10%;

          & > div {
            width: 30%;
            h3 {
              color: #fff;
              font-size: 2.4vh;
              margin-bottom: 30px;
            }
            a {
              margin-right: 2vh;
              letter-spacing: 2px;
              font-weight: bold;
            }

            .router2 {
              div {
                margin-bottom: 20px;
              }

              a {
                font-size: 2vh;
                color: #fff;
                letter-spacing: 2px;
                font-weight: normal;
              }
            }
            &:last-child {
              width: 40%;
            }
          }
          .footerMenu {
            color: #fff;
            .li {
              font-size: 2vh;
              font-weight: 400;
              color: #ffffff;
              margin-bottom: 20px;
              a {
                color: #fff;
              }
              p {
                line-height: 24px;
              }
            }
          }
          .footerShare {
            display: flex;

            a {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 38px;
              height: 38px;
              border: 1px solid #a1a1a1;
              border-radius: 50%;
              color: #a1a1a1;
              margin-right: 8px;
              font-size: 20px;
              &:hover {
                background-color: #00bebe;
                color: #fff;
              }
            }
          }
        }
        .left-content1 {
          display: flex;
          padding: 0 35px;
          border-right: 1px solid #242424;
          flex-direction: column;
          color: #fff;
          &:last-child {
            border-right: none;
          }
          .des {
            padding: 12.5px 0;
            color: #808080;
            line-height: 1;
            font-size: 14px;
          }
          .title {
            font-size: 14px;
            color: #808080;
            padding: 15px 0 20px;
          }
          .phone {
            font-size: 22px;
            color: #ccc;
          }
          .time {
            font-size: 22px;
            color: #ccc;
          }
        }
      }
      .right {
        width: 130px;
        .img {
          width: 100%;
          display: block;
        }
        .des {
          font-size: 12px;
          color: #666;
          padding-top: 15px;
          text-align: center;
        }
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .contact {
    .main {
      width: 96%;
      padding: 0;
      display: block;
      .left {
        width: 100%;
        .title {
          text-align: center;
          font-size: 3vh;
          margin-bottom: 30px;
        }
        p {
          width: 90%;
          margin: 0 auto 30px;
        }
      }
      .right {
        width: 100%;
        .title {
          text-align: center;
          font-size: 3vh;
          margin-bottom: 30px;
        }
        form {
          width: 90%;
          margin: 0 auto;
        }
      }
    }
  }
  .footer {
    // display: none;
    .index-container .footer-body {
      display: block;
      .left {
        display: block;
        .leftF {
          display: block;
          margin-left: 0;
          margin-top: 20px;
          & > div:nth-child(1),
          & > div:nth-child(2) {
            display: none;
          }
          & > div:nth-child(3) {
            width: 100%;
          }
          .footerShare a {
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>
